import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "../../../../api/axios";
import {
  CEPInput,
  DocumentInput,
  EmailInput,
  PhoneInput,
  TextFieldComponent,
} from "../../../../components/misc/form";
import useAlert from "../../../../globalComponents/useAlerts";

const CreateCustomer = () => {
  const { showLoading, showAlert, dismissLoading } = useAlert();
  const [form, setForm] = useState({
    name: "",
    phone: "",
    document: "",
    type: "PF",
    businessName: "",
    email: "",
    birthdate: "",
    address: {
      street: "",
      number: "",
      complement: "",
      reference: "",
      neighborhood: "",
      zipCode: "",
      city: "",
      state: "",
    },
  });

  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();
  const [loading, setLoading] = useState(false);

  const { birthDate } = watch();

  const handleSubmit = async (form) => {
    try {
      showLoading();
      const data = await axios.post("/customers", form);
      setSuccess(true);
      setTimeout(() => navigate("./../" + data._id), 1500);
    } catch (err) {
      showAlert({ title: "Atenção", description: err.message });
    } finally {
      dismissLoading();
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh", // full screen
        //=display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 30,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Cadastro de Cliente
      </Typography>

      <Paper
        elevation={3}
        sx={{
          //width: 400,
          maxHeight: "80vh", // limit height
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          onSubmit={formSubmit(handleSubmit)}
          component="form"
          sx={{
            p: 2,
            overflowY: "auto", // 🔥 enables scroll
            flex: 1, // fills available space
          }}
        >
          <Grid container spacing={2} mt={1}>
            <Typography variant="h6" mt={1}>
              Dados pessoais
            </Typography>

            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
              <TextFieldComponent
                name="name"
                control={control}
                label={"Nome"}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 8, md: 8 }}>
              <DocumentInput
                size="small"
                control={control}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <TextFieldComponent
                name="birthDate"
                control={control}
                type="date"
                label={"Data Nasc.:"}
                focused={!birthDate}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <PhoneInput size="small" control={control} fullWidth required />
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 8 }}>
              <EmailInput size="small" control={control} fullWidth />
            </Grid>

            <Typography variant="h6" mt={3}>
              Endereço
            </Typography>

            <Grid container spacing={2} mt={1}>
              <Grid size={{ xs: 12, sm: 8, md: 8 }}>
                <TextFieldComponent
                  name="address.street"
                  control={control}
                  label={"Logradouro"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <TextFieldComponent
                  name="address.number"
                  control={control}
                  label={"Número"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.complement"
                  control={control}
                  label={"Complemento"}
                  fullWidth
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.reference"
                  control={control}
                  label={"Referência"}
                  fullWidth
                  
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 8, md: 8 }}>
                <TextFieldComponent
                  name="address.neighborhood"
                  control={control}
                  label={"Bairro"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <CEPInput
                  size="small"
                  control={control}
                  name="address.zipCode"
                  onAddressFound={(address) => {
                    Object.keys(address).forEach((key) =>
                      setValue(`address.${key}`, address[key], {
                        shouldDirty: true,
                      }),
                    );
                  }}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.city"
                  control={control}
                  label={"Cidade"}
                  fullWidth
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.state"
                  control={control}
                  label={"Estado"}
                  fullWidth
                  required
                />
              </Grid>
              {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.latitude"
                  control={control}
                  label={"Latitude"}
                  fullWidth
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <TextFieldComponent
                  name="address.longitude"
                  control={control}
                  label={"Longitude"}
                  fullWidth
                />
              </Grid> */}
            </Grid>
          </Grid>

          <Grid item>
            <Button
              loading={loading}
              variant="contained"
              color="primary"
              type="submit"
              sx={{ mt: 3 }}
            >
              Salvar
            </Button>
          </Grid>
        </Box>
      </Paper>

      <Snackbar open={success} autoHideDuration={3000}>
        <Alert severity="success">Cliente cadastrado com sucesso!</Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateCustomer;
